import React from 'react'
import { CBadge } from '@coreui/react-pro'

export const GAME_TYPES = {
  1: { label: 'Club (Outdoor)', color: 'success' },
  2: { label: 'League', color: 'info' },
  3: { label: 'Indoor-Cricket', color: 'primary' },
}

export const PLAN_TYPES = { 1: 'Starter', 2: 'Pro-1', 3: 'Pro-2' }

// Platform keeps 15% of Stripe game-pass payments.
export const PLATFORM_FEE_RATE = 0.15

export const sumAmounts = (payments) =>
  (payments || []).reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0)

export const formatMoney = (symbol, value) =>
  `${symbol || '$'}${(parseFloat(value) || 0).toFixed(2)}`

export const gameModeLabel = (teamView) => (teamView === 0 ? 'Position Based' : 'Position Free')

export const gamePassLabel = (collect) => (collect == 0 ? 'Free' : 'Collection Method Applied')

export const collectionMethodLabel = (collect) =>
  collect === 1 ? 'MCT' : collect === 2 ? 'Self' : null

export const GameTypeBadge = ({ type }) => {
  const meta = GAME_TYPES[type]
  if (!meta) return <span className="um-muted">-</span>
  return (
    <CBadge color={meta.color} shape="rounded-pill" className="px-2 py-1">
      {meta.label}
    </CBadge>
  )
}

export const PlanBadge = ({ plan }) => {
  const label = PLAN_TYPES[plan]
  if (!label) return <span className="um-muted">-</span>
  return (
    <CBadge color="primary" shape="rounded-pill" className="px-2 py-1">
      {label}
    </CBadge>
  )
}

export const YesNoBadge = ({ value, yes = 'Yes', no = 'No' }) => (
  <CBadge color={value ? 'success' : 'secondary'} shape="rounded-pill" className="px-2 py-1">
    {value ? yes : no}
  </CBadge>
)
